import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import NotConfigured from './pages/NotConfigured';
import { AuthProvider } from './lib/auth';
import { isConfigured } from './lib/api';
import { ToastProvider } from './components/ui';
import './index.css';

/*
 * Restore the saved theme before first paint so there is no flash.
 *
 * Light unless the reader has explicitly chosen dark — matching the attribute
 * already on <html> in index.html, which is what governs if this script never
 * runs. Only an exact 'dark' switches: a junk value left by an older build, or
 * storage being blocked entirely, lands on the default rather than on
 * whatever that string happens to be.
 */
try {
  const saved = localStorage.getItem('provia.theme');
  document.documentElement.setAttribute('data-theme', saved === 'dark' ? 'dark' : 'light');
} catch {
  document.documentElement.setAttribute('data-theme', 'light');
}

// Before anything else: if config.js still has the placeholder, there is no
// backend to talk to and every screen would fail with a network error. Say so
// plainly instead, and skip mounting the app at all.
const root = ReactDOM.createRoot(document.getElementById('root')!);

if (!isConfigured()) {
  root.render(
    <React.StrictMode>
      <NotConfigured />
    </React.StrictMode>,
  );
} else {
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
}
